import React from 'react';
import { css } from '@emotion/react';
import { Text, Button, Flex, Icon } from '@pairy/pds-react';

import SortTypeDropdown from '../../../SortTypeDropdown';

import * as Styled from './index.styles';

interface Props {
  addAllClients: () => void;
}

const items = [{ label: '고객 대표명 순', value: 'name' }] as const;

const buttonCss = css`
  min-width: 61px;
  height: 17px;
  padding: 0 0 0 8px;
  border: 0;
`;

const ExistingClient = ({
  children,
  addAllClients,
}: React.PropsWithChildren<Props>) => {
  return (
    <>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex display="inline-flex">
          <Text variant="md-semibold" marginRight={8}>
            고객 목록
          </Text>
          <SortTypeDropdown
            items={items}
            onValueChanges={() => {}}
            buttonCss={buttonCss}
            align="start"
            sideOffset={12}
          />
        </Flex>
        <Button
          variant="skyblue_400"
          textVariant="sm-semibold"
          borderLess
          rightIcon={<Icon icon="ph:plus" size={17} />}
          onClick={() => addAllClients()}
        >
          모두 추가하기
        </Button>
      </Flex>
      <Styled.StackClientListWrapper direction="column" gap={8}>
        {children}
      </Styled.StackClientListWrapper>
    </>
  );
};

export default ExistingClient;
